import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import ErrorBoundary from "@/components/common/ErrorBoundary";
import Layout from "@/components/layout/Layout";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import DesktopAgent from "@/pages/DesktopAgent";
import Industries from "@/pages/Industries";
import Process from "@/pages/Process";
import About from "@/pages/About";
import Insights from "@/pages/Insights";
import InsightArticle from "@/pages/InsightArticle";
import Contact from "@/pages/Contact";
import LegalPage from "@/pages/LegalPage";
import BrandReview from "@/pages/BrandReview";
import Admin from "@/pages/Admin";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <Routes>
          <Route path="/admin" element={<Admin />} />
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/mythoros" element={<DesktopAgent />} />
            <Route path="/desktop-ai-agent" element={<Navigate to="/mythoros" replace />} />
            <Route path="/industries" element={<Industries />} />
            <Route path="/process" element={<Process />} />
            <Route path="/about" element={<About />} />
            <Route path="/insights" element={<Insights />} />
            <Route path="/insights/:slug" element={<InsightArticle />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy-policy" element={<LegalPage type="privacy" />} />
            <Route path="/terms-of-use" element={<LegalPage type="terms" />} />
            <Route path="/accessibility" element={<LegalPage type="accessibility" />} />
            <Route path="/brand-review" element={<BrandReview />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" theme="light" />
    </ErrorBoundary>
  );
}

export default App;
